import Course from './modules/Course';
import Company from './modules/Company';
import Cockpit from './modules/Cockpit';
import Lti from './modules/Lti';
import Training from './modules/Training';
import Enrollment from './modules/Enrollment';
import OpenLibrary from './modules/OpenLibrary';
import CourseGroup from './modules/CourseGroup';
import EnrollmentGroup from './modules/EnrollmentGroup';

export default {
  Course,
  Company,
  Cockpit,
  Lti,
  Training,
  Enrollment,
  OpenLibrary,
  CourseGroup,
  EnrollmentGroup,
};
